import { ArrowUpRight } from "lucide-react";
import { CASE_STUDIES } from "@/lib/siteData";

export const CaseStudies = () => {
  return (
    <section
      id="case-studies"
      data-testid="case-studies-section"
      className="relative py-24 sm:py-32 bg-[#1E2A1E]/30"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
          <div className="max-w-3xl">
            <div className="text-xs tracking-[0.25em] uppercase font-bold text-[#E3A21A] mb-4">
              Case Studies · Real Numbers
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#F5F5F0] font-medium">
              Receipts,
              <br />
              <span className="text-[#E3A21A] italic font-light">not promises.</span>
            </h2>
          </div>
          <p className="max-w-md text-[#A8B8A8] text-base leading-relaxed">
            Six recent engagements across real estate, lifestyle and education.
            Hover over any card to see the story.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {CASE_STUDIES.map((cs, idx) => (
            <article
              key={cs.id}
              data-testid={`case-study-${cs.id}`}
              className="group relative rounded-2xl bg-[#1E2A1E] border border-[#E3A21A]/10 p-7 md:p-8 overflow-hidden hover:border-[#E3A21A]/40 transition-all duration-500 hover:-translate-y-1"
            >
              {/* gold glow on hover */}
              <div className="absolute -top-24 -right-24 h-48 w-48 rounded-full bg-[#E3A21A]/10 blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

              <div className="relative z-10 flex items-start justify-between mb-6">
                <span
                  className={`text-[10px] tracking-[0.2em] uppercase font-bold px-3 py-1.5 rounded-full border ${cs.tagColor}`}
                >
                  {cs.category}
                </span>
                <span className="font-mono text-xs text-[#A8B8A8]">
                  0{idx + 1} / 06
                </span>
              </div>

              <h3 className="relative z-10 font-display text-2xl md:text-[28px] text-[#F5F5F0] tracking-tight font-medium leading-tight">
                {cs.headline}
              </h3>

              <div className="relative z-10 mt-7 grid grid-cols-3 gap-3">
                {cs.metrics.map((m, i) => (
                  <div
                    key={i}
                    className="rounded-xl bg-[#121A12] border border-[#E3A21A]/10 p-3 md:p-4 text-center"
                  >
                    <div className="font-display text-2xl md:text-3xl font-semibold text-[#E3A21A] tracking-tight leading-none">
                      {m.big}
                    </div>
                    <div className="mt-1.5 text-[10px] md:text-[11px] text-[#A8B8A8] leading-tight">
                      {m.label}
                    </div>
                  </div>
                ))}
              </div>

              <p className="relative z-10 mt-6 text-sm text-[#A8B8A8] leading-relaxed">
                {cs.summary}
              </p>

              <div className="relative z-10 mt-7 pt-5 border-t border-[#E3A21A]/10 flex items-center justify-between">
                <span className="text-[10px] tracking-[0.25em] uppercase font-bold text-[#E3A21A]">
                  Delivered by Digibis
                </span>
                <ArrowUpRight className="h-4 w-4 text-[#A8B8A8] group-hover:text-[#E3A21A] group-hover:rotate-45 transition-all duration-300" />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
